module.exports = __webpack_public_path__ + "static/media/medialog_location.080b63e8.png";